document.addEventListener("DOMContentLoaded", function () {
  Fancybox.bind(".hc-popup-link a", {
    hideScrollbar: false,
    closeButton: "inside",
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var desc = document.querySelector(".collection-description-content");
  var btn = document.getElementById("hc-read-more-toggle");

  if (!desc || !btn) return;

  var originalHeight = desc.scrollHeight;
  if (desc.offsetHeight >= originalHeight) {
    btn.style.display = 'none';
  }

  btn.addEventListener("click", function () {
    desc.classList.toggle("expanded");
    btn.textContent = desc.classList.contains("expanded") ? "Read less" : "Read more";
  });
});
